module.exports = __webpack_public_path__ + "img/sector1.ccb29274.jpg";